import { useMemo } from 'react';

import { parseUnits } from 'viem';

import { useCurrenciesStore } from 'shared/store/currenciesStore';

const GAMES_LIST = [
  { type: 'short', wins: 3 },
  { type: 'medium', wins: 6 },
  { type: 'long', wins: 9 },
] as const;

export const useQuickGames = () => {
  const { selectedCurrency, isLoadingBalances } = useCurrenciesStore();

  const quickGames = useMemo(() => {
    if (!selectedCurrency || isLoadingBalances) return [];

    const bets = selectedCurrency.bet ?? [];
    const minBet = selectedCurrency.minBet ?? 0;

    return GAMES_LIST.map(({ type, wins }) => {
      let amount: number;

      if (type === 'short') {
        amount = Number(bets[0] ?? minBet);
      } else if (type === 'medium') {
        amount =
          bets.length > 1
            ? Number(((Number(bets[0] ?? minBet) + Number(bets[1] ?? minBet)) / 2).toFixed(5))
            : Number(bets[0] ?? minBet);
      } else {
        amount = bets.length > 1 ? Number(bets[1]) : Number(bets[0] ?? minBet);
      }

      return {
        type,
        wins,
        amount: parseUnits(amount.toString(), selectedCurrency.decimals),
        currency: selectedCurrency,
      };
    });
  }, [selectedCurrency, isLoadingBalances]);

  return { quickGames, isLoadingBalances, selectedCurrency };
};
